export const DEPOSIT_SUCCESS_MODAL_COMMISSION_ITEMS = [
  { commissionsName: "Current Vault Price:", commissionsValue: "" },

  // Monthly Subscription is temporarily disabled.
  // { commissionsName: "Monthly Subscription:", commissionsValue: CUSTODY_FEE },
  { commissionsName: "Withdrawal fee:", commissionsValue: "" },
];
